import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 12.031 11.969",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 12.031 11.969\" id=\"pencil\"><path d=\"m7.462 1.971 2.441 2.453-6.179 6.21-2.44-2.453 6.178-6.21Zm4.293-.591L10.667.286a1.076 1.076 0 0 0-1.526 0L8.098 1.334l2.441 2.453 1.216-1.223a.837.837 0 0 0 0-1.184ZM.007 11.629a.278.278 0 0 0 .336.332l2.72-.663-2.44-2.453-.616 2.784Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol